module.exports = __webpack_public_path__ + "img/k-orange-back-woman.beee0e86.jpg";